module.exports = __webpack_public_path__ + "static/media/az.001eb942.svg";